import { Slide, toast, ToastOptions } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

const options: ToastOptions = {
  position: 'top-right',
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  transition: Slide,
}

export const showToast = {
  info: (message: string) => toast.info(message, options),
  success: (message: string) => toast.success(message, options),
  warning: (message: string) => toast.warning(message, options),
  error: (message: string) => toast.error(message, options),
}

export type ToastType = typeof showToast
